import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useContext, useImperativeHandle, useRef, useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { CheckoutAddress } from "@components/organisms";
import { useAuth, useCheckout, useCart } from "@saleor/sdk";
import { ShopContext } from "@temp/components/ShopProvider/context";
import { checkoutMessages, commonMessages } from "@temp/intl";
import { filterNotEmptyArrayItems } from "@utils/misc";

var CheckoutAddressSubpageWithRef = function CheckoutAddressSubpageWithRef(_ref, ref) {
  var _user$currentTrade2, _user$currentTrade2$n, _userAddressToShow;

  var changeSubmitProgress = _ref.changeSubmitProgress,
      onSubmitSuccess = _ref.onSubmitSuccess,
      props = _objectWithoutProperties(_ref, ["changeSubmitProgress", "onSubmitSuccess"]);

  var checkoutShippingAddressFormId = "shipping-address-form";
  var checkoutShippingAddressFormRef = useRef(null);
  var checkoutNewAddressFormId = "new-address-form";
  var navigate = useNavigate();

  var _useAuth = useAuth(),
      user = _useAuth.user;

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout,
      selectedShippingAddressId = _useCheckout.selectedShippingAddressId,
      setShippingAddress = _useCheckout.setShippingAddress;

  var _useCart = useCart(),
      items = _useCart.items;

  var _useContext = useContext(ShopContext),
      countries = _useContext.countries;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      shippingErrors = _useState2[0],
      setShippingErrors = _useState2[1];

  var intl = useIntl();
  var nameOptions = React.useMemo(function () {
    return [{
      id: intl.formatMessage(checkoutMessages.other),
      name: intl.formatMessage(checkoutMessages.other)
    }, {
      id: intl.formatMessage(checkoutMessages.myHome),
      name: intl.formatMessage(checkoutMessages.myHome)
    }, {
      id: intl.formatMessage(checkoutMessages.myJob),
      name: intl.formatMessage(checkoutMessages.myJob)
    }, {
      id: intl.formatMessage(checkoutMessages.myBoyfriendHouse),
      name: intl.formatMessage(checkoutMessages.myBoyfriendHouse)
    }];
  }, []);
  var isShippingRequiredForProducts = items && items.some(function (_ref2) {
    var _variant$product;

    var variant = _ref2.variant;
    return (_variant$product = variant.product) === null || _variant$product === void 0 ? void 0 : _variant$product.productType.isShippingRequired;
  });
  var checkoutShippingAddress = (checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress) ? _objectSpread(_objectSpread({}, checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress), {}, {
    email: (checkout === null || checkout === void 0 ? void 0 : checkout.email) || (user === null || user === void 0 ? void 0 : user.email)
  }) : undefined;
  useImperativeHandle(ref, function () {
    return {
      submitAddress: function submitAddress() {
        var _checkoutShippingAddr;

        (_checkoutShippingAddr = checkoutShippingAddressFormRef.current) === null || _checkoutShippingAddr === void 0 ? void 0 : _checkoutShippingAddr.dispatchEvent(new Event("submit", {
          cancelable: true
        }));
      }
    };
  });

  var handleSetShippingAddress = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(address, email, userAddressId) {
      var shippingEmail, _yield$setShippingAdd, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              localStorage.setItem("select-address-inprogress", "true");

              if (address) {
                _context.next = 5;
                break;
              }

              setShippingErrors([{
                message: intl.formatMessage(_defineProperty({
                  defaultMessage: "Please provide shipping address.",
                  "id": "@next.pages.CheckoutPage.subpages.CheckoutAddressSubpage.929802659"
                }, "id", "@next.pages.CheckoutPage.subpages.CheckoutAddressSubpage.929802659"))
              }]);
              localStorage.removeItem("select-address-inprogress");
              return _context.abrupt("return");

            case 5:
              shippingEmail = (user === null || user === void 0 ? void 0 : user.email) || email || "";

              if (shippingEmail) {
                _context.next = 10;
                break;
              }

              setShippingErrors([{
                field: "email",
                message: intl.formatMessage(commonMessages.provideEmailAddress)
              }]);
              localStorage.removeItem("select-address-inprogress");
              return _context.abrupt("return");

            case 10:
              changeSubmitProgress(true);
              _context.next = 13;
              return setShippingAddress(_objectSpread(_objectSpread({}, address), {}, {
                id: userAddressId
              }), shippingEmail);

            case 13:
              _yield$setShippingAdd = _context.sent;
              dataError = _yield$setShippingAdd.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (!errors) {
                _context.next = 22;
                break;
              }

              setShippingErrors(errors);
              changeSubmitProgress(false);
              localStorage.removeItem("select-address-inprogress");
              _context.next = 26;
              break;

            case 22:
              setShippingErrors([]);
              changeSubmitProgress(false);
              localStorage.removeItem("select-address-inprogress");
              return _context.abrupt("return", navigate("/checkout/shipping"));

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSetShippingAddress(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var currentNeighborhood = React.useMemo(function () {
    var _user$currentTrade, _user$currentTrade$ne;

    return user === null || user === void 0 ? void 0 : (_user$currentTrade = user.currentTrade) === null || _user$currentTrade === void 0 ? void 0 : (_user$currentTrade$ne = _user$currentTrade.neighborhoodsAttention) === null || _user$currentTrade$ne === void 0 ? void 0 : _user$currentTrade$ne.map(function (data) {
      return data === null || data === void 0 ? void 0 : data.id;
    });
  }, [user]);
  var userAddressesFilter = React.useMemo(function () {
    var _user$addresses;

    return user === null || user === void 0 ? void 0 : (_user$addresses = user.addresses) === null || _user$addresses === void 0 ? void 0 : _user$addresses.filter(function (data) {
      return currentNeighborhood === null || currentNeighborhood === void 0 ? void 0 : currentNeighborhood.includes(data === null || data === void 0 ? void 0 : data.neighborhood.id);
    });
  }, [user, currentNeighborhood]);
  var validateUserDefaultShippingAddress = React.useMemo(function () {
    return userAddressesFilter === null || userAddressesFilter === void 0 ? void 0 : userAddressesFilter.findIndex(function (data) {
      var _user$defaultShipping;

      return (data === null || data === void 0 ? void 0 : data.id) === (user === null || user === void 0 ? void 0 : (_user$defaultShipping = user.defaultShippingAddress) === null || _user$defaultShipping === void 0 ? void 0 : _user$defaultShipping.id);
    });
  }, [user, userAddressesFilter]);
  var userAddressPosition;

  if (checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress) {
    var userAddressPositionTemporal = userAddressesFilter === null || userAddressesFilter === void 0 ? void 0 : userAddressesFilter.findIndex(function (data) {
      var _checkout$shippingAdd, _checkout$shippingAdd2, _data$neighborhood, _checkout$shippingAdd3, _checkout$shippingAdd4;

      return (data === null || data === void 0 ? void 0 : data.firstName) === (checkout === null || checkout === void 0 ? void 0 : (_checkout$shippingAdd = checkout.shippingAddress) === null || _checkout$shippingAdd === void 0 ? void 0 : _checkout$shippingAdd.firstName) && (data === null || data === void 0 ? void 0 : data.streetAddress1) === (checkout === null || checkout === void 0 ? void 0 : (_checkout$shippingAdd2 = checkout.shippingAddress) === null || _checkout$shippingAdd2 === void 0 ? void 0 : _checkout$shippingAdd2.streetAddress1) && (data === null || data === void 0 ? void 0 : (_data$neighborhood = data.neighborhood) === null || _data$neighborhood === void 0 ? void 0 : _data$neighborhood.id) === (checkout === null || checkout === void 0 ? void 0 : (_checkout$shippingAdd3 = checkout.shippingAddress) === null || _checkout$shippingAdd3 === void 0 ? void 0 : (_checkout$shippingAdd4 = _checkout$shippingAdd3.neighborhood) === null || _checkout$shippingAdd4 === void 0 ? void 0 : _checkout$shippingAdd4.id);
    });

    if (userAddressPositionTemporal === -1 && validateUserDefaultShippingAddress) {
      userAddressPosition = validateUserDefaultShippingAddress;
    } else {
      userAddressPosition = userAddressPositionTemporal;
    }
  } else {
    userAddressPosition = validateUserDefaultShippingAddress;
  }

  var userAddressToShow = [];

  if (userAddressPosition !== -1 && userAddressPosition !== undefined) {
    var userAddressFirstPart = userAddressesFilter === null || userAddressesFilter === void 0 ? void 0 : userAddressesFilter.slice(0, userAddressPosition);
    var userAddressSecondPart = userAddressesFilter === null || userAddressesFilter === void 0 ? void 0 : userAddressesFilter.slice(userAddressPosition + 1, userAddressesFilter.length);
    var userAddressShippingDefault = userAddressesFilter === null || userAddressesFilter === void 0 ? void 0 : userAddressesFilter.slice(userAddressPosition, userAddressPosition + 1);
    var finalUserAddresses = [].concat(_toConsumableArray(userAddressShippingDefault || []), _toConsumableArray(userAddressFirstPart || []), _toConsumableArray(userAddressSecondPart || []));

    if (finalUserAddresses.length > 0) {
      finalUserAddresses.map(function (data, index) {
        if (data !== null) {
          if (index === 0) {
            data.desktopView = true;
            return;
          }

          if (index === 2) {
            data.desktopViewThirdElement = true;
            return;
          }

          if (index === 1) {
            data.desktopView = false;
            data.desktopViewThirdElement = false;
            data.OtherAddress = true;
            return;
          }

          data.desktopView = false;
          data.OtherAddress = false;
          data.desktopViewThirdElement = false;
        }
      });
      userAddressToShow = finalUserAddresses;
    } else {
      userAddressToShow = [];
    }
  } else {
    userAddressesFilter === null || userAddressesFilter === void 0 ? void 0 : userAddressesFilter.map(function (data, index) {
      if (data !== null) {
        if (index === 0) {
          data.desktopView = true;
          return;
        }

        if (index === 2) {
          data.desktopViewThirdElement = true;
          return;
        }

        if (index === 1) {
          data.desktopView = false;
          data.desktopViewThirdElement = false;
          data.OtherAddress = true;
          return;
        }

        data.desktopView = false;
        data.OtherAddress = false;
        data.desktopViewThirdElement = false;
      }
    });
    userAddressToShow = userAddressesFilter || [];
  }

  var neighborhoodsAttention = [];
  user === null || user === void 0 ? void 0 : (_user$currentTrade2 = user.currentTrade) === null || _user$currentTrade2 === void 0 ? void 0 : (_user$currentTrade2$n = _user$currentTrade2.neighborhoodsAttention) === null || _user$currentTrade2$n === void 0 ? void 0 : _user$currentTrade2$n.forEach(function (data) {
    neighborhoodsAttention.push({
      id: data === null || data === void 0 ? void 0 : data.id,
      name: data === null || data === void 0 ? void 0 : data.name
    });
  });
  var userAddresses = (_userAddressToShow = userAddressToShow) === null || _userAddressToShow === void 0 ? void 0 : _userAddressToShow.filter(filterNotEmptyArrayItems).map(function (address) {
    return {
      address: _objectSpread(_objectSpread({}, address), {}, {
        isDefaultBillingAddress: address.isDefaultBillingAddress || false,
        isDefaultShippingAddress: address.isDefaultShippingAddress || false,
        phone: address.phone || undefined
      }),
      id: (address === null || address === void 0 ? void 0 : address.id) || "",
      onSelect: function onSelect() {
        return null;
      },
      onEdit: function onEdit() {
        return null;
      }
    };
  });
  useEffect(function () {
    localStorage.removeItem("flag-input-other-values");
    return function () {};
  }, []);
  return React.createElement(CheckoutAddress, _extends({}, props, {
    shippingErrors: shippingErrors,
    shippingFormId: checkoutShippingAddressFormId,
    shippingFormRef: checkoutShippingAddressFormRef,
    checkoutShippingAddress: checkoutShippingAddress,
    email: checkout === null || checkout === void 0 ? void 0 : checkout.email,
    userAddresses: userAddresses,
    selectedUserShippingAddressId: selectedShippingAddressId,
    countries: countries,
    userId: user === null || user === void 0 ? void 0 : user.id,
    nameOptions: nameOptions,
    newAddressFormId: checkoutNewAddressFormId,
    neighborhoodsAttention: neighborhoodsAttention,
    shippingAddressRequired: !!isShippingRequiredForProducts,
    setShippingAddress: handleSetShippingAddress
  }));
};

var CheckoutAddressSubpage = forwardRef(CheckoutAddressSubpageWithRef);
export { CheckoutAddressSubpage };